import { useCallback } from 'react';
import type { IScreensLogging } from 'shared/src/api/types';
import { bridge } from 'shared/src/utils';

type LogViewFeedbackModalParams = {
  logging?: IScreensLogging;
};

export const useLogViewFeedbackModal = (screen?: string) => {
  return useCallback(
    ({ logging }: LogViewFeedbackModalParams) => {
      bridge.logAnalyticsEvent({
        name: 'VIEW_FEEDBACK_MODAL',
        analytics: {
          ...logging?.analytics,
          ...(screen != null && screen !== '' && { SCREEN: screen }),
        },
        ably_only_log: logging?.ably_only_log,
      });
    },
    [screen],
  );
};
